<template>
<div v-if="isShow">
    <!-- Register 2 - input phone number -->
    <div v-if="!isShowVerifyPhone">
        <header>新規登録<div class="h-left"><a @click="$emit('close', formData)"><img src="~@/assets/images/icon02.svg"></a></div>
        </header>
        <div id="wrap">
            <div class="txt-area">
                <p>次に、あなたがロボットや業者でないことを証明するために電話番号を入力してください。</p>
            </div>
            <div class="cp_iptxt">
                <input pattern="[0-9]*" inputmode="numeric" type="text" name="phone" placeholder="携帯電話番号" maxlength="11" v-model="formData.phone" autocomplete="off">
                <i class="fas fa-mobile-alt fa-lg fa-fw" aria-hidden="true"></i>
            </div>
            <p class="login-4">SMSを受け取ることができる携帯電話番号を入力してください</p>

            <div :class="checkPhone() ? 'btn1' : 'btn3'" id="btn_input_phone"><a @click="submit()">次へ</a></div>

        </div>
    </div>
    <revifyPhone :dataPhone="formData.phone" :isShow="isShowVerifyPhone" @close="closeVerifyPhone" @changePhone="changePhone"></revifyPhone>
</div>
</template>

<script>
import revifyPhone from "./revifyPhone"
export default {
    components: {
        revifyPhone
    },
    props: {
        isShow: Boolean,
        phoneData: Object,
        isVerifyPhone: Boolean
    },
    data: () => ({
        formData: {
            phone: null
        },
        isShowVerifyPhone: false,
    }),
    mounted() {
        window.scrollTo(0, 0)
        if (this.phoneData) {
            this.formData.phone = this.phoneData.phone
        }
        if (this.isVerifyPhone) {
            this.isShowVerifyPhone = true
        } else {
            this.isShowVerifyPhone = false
        }

    },
    watch: {
        isVerifyPhone(val) {
            if (val) {
                this.isShowVerifyPhone = true
            } else {
                this.isShowVerifyPhone = false
            }
        },
        isShowVerifyPhone() {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 10)
        }
    },

    computed: {

    },
    methods: {
        checkPhone() {
            if (this.formData.phone) {
                this.formData.phone = this.formData.phone.replace(/\D/g,'');
            }
            if (this.formData.phone && this.formData.phone.length === 11) {
                return true
            } else false
        },
        submit() {
            if (this.checkPhone()) {
                this.$emit('submit', this.formData)
                if (this.isVerifyPhone) {
                    this.isShowVerifyPhone = true
                } else {
                    this.isShowVerifyPhone = false
                }
            }
        },

        closeVerifyPhone() {
            // this.isShowVerifyPhone = false
            this.$emit('submitVerifyPhone', this.formData)
        },
        changePhone(phone) {
            this.formData.phone = phone
            this.$emit('changePhone', this.formData)
        }
    }
}
</script>
